import React from 'react';
import { Header } from './Header';
import { TooltipProvider } from '../ui/tooltip';

interface MainLayoutProps {
  children: React.ReactNode;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <TooltipProvider>
      <div className="min-h-screen bg-background">
        <Header />
        <div className="w-full">
          {children}
        </div>
      </div>
    </TooltipProvider>
  );
};